import { RemiLogger } from "./remi-logger";
import type { ILogger } from "./types";

function formatArgs(args: unknown[]) {
  const newArgs = args.reduce<unknown[]>((acc, arg) => {
    // If error, format
    if (typeof arg === "object" && arg !== null && "error" in arg) {
      if (arg.error instanceof Error) {
        acc.push({
          ...arg,
          error: arg.error.toString(),
        });
        return acc;
      }

      if (
        arg.error &&
        typeof arg.error === "object" &&
        "response" in arg.error &&
        arg.error.response &&
        typeof arg.error.response === "object" &&
        "data" in arg.error.response
      ) {
        acc.push({
          ...arg,
          error: arg.error.toString(),
          response: arg.error.response,
          responseBody: arg.error.response.data,
        });
        return acc;
      }
    }

    if (arg instanceof Error) {
      acc.push(arg.message);
      return acc;
    }

    acc.push(arg);
    return acc;
  }, []);

  return newArgs;
}

const logger: ILogger = {
  info: (...args: unknown[]) => {
    console.log(...formatArgs(args));
  },
  error: (...args: unknown[]) => {
    console.error(...formatArgs(args));
  },
  warn: (...args: unknown[]) => {
    console.warn(...formatArgs(args));
  },
  debug: (...args: unknown[]) => {
    console.debug(...formatArgs(args));
  },
  child: (..._args: unknown[]) => {
    return logger;
  },
};

export const remiLogger = new RemiLogger(logger);

const quietLogger: ILogger = {
  ...logger,
  info: () => {},
  debug: () => {},
  child: () => quietLogger,
};

export const quietRemiLogger = new RemiLogger(quietLogger);
